export default __webpack_public_path__ + "static/media/eski.91b399e7.jfif";